import { useContext } from "react";
import { UploadContext } from "../providers/UploadHubProvider";
import { UploadHubContextProps } from "../types/upload.types";

export const useUploadHub = (): UploadHubContextProps => {
  const context = useContext(UploadContext);
  if (!context) {
    throw new Error("useUploadHub must be used within a UploadHubProvider");
  }

  return context;
};
